module.exports = __webpack_public_path__ + "static/media/2 (28).316728d3.jpg";